module.exports = __webpack_public_path__ + "static/media/button_minatodbdfe74bedbb70c4be2fcfecea1526b5.webp";